import _ from "lodash";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  FormControl as MuiFormControl,
  InputLabel,
  Box,
  useMediaQuery,
  FormControlLabel,
  Checkbox,
  MenuItem,
  Radio,
  RadioGroup,
} from "@mui/material";

import TextInput from "../../../toolkit/TextInput";
import Select from "@mui/material/Select";
import RadioButtons from "../../../toolkit/RadioButtons";
import CheckboxGroup from "../../../toolkit/CheckboxGroup";
import theme from "../../../themes/baseTheme";
// import "../../../styles/FormControl.css";
import ErrorIcon from "@mui/icons-material/Error";
import Number from "../../../toolkit/Number";
// import Button from "../../../toolkit/Button";
import { Button } from "@mui/material";
import Enum from "../../../utils/Enums";

import FinancialData from "../../financialanalytics/FinancialData/FinancialData";
import axios from "../../../utils/fvAxios";
import { useNavigate } from "react-router-dom";

import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import { ToastContainer, toast } from "react-toastify";
import { Stack } from "@mui/system";
import QuestionColumn from "./QuestionColumn";

const defaultQuestionColumnDetailObject = {
  checklistQuestionColumnDetailsId: 0,
  columnNo: 1,
  tableReference: {
    qcTableReference: null,
    qcTableReferenceField: null,
    qcTableRefFieldValueDisplay: null,
  },
  qFormula: null,
  answer: null,
  type: null,
  displayType: 0,
  questionControlTypeId: 0,
  options: null,
  alignment: null,
  checkListUserInputId: 0,
  buttonTypeReferenceValue: null,
  hasUserInput: false,
};
export default function QuestionColumns({
  questionColumnDetails,
  details,
  numberOfColumns,
  setQuestionColumnDetails,
  // setRequired,
  ...props
}) {
  const areColumnsPropsDifferent = (array) => {
    if (array.length > 1) {
      const firstColumn = array[0];
      const {
        questionControlTypeId,
        options,
        displayType,
        questionPlaceholder,
        qFormula,
        buttonTypeReferenceValue,
        tableReference,
      } = firstColumn;

      return array.some(
        (item) =>
          item.questionControlTypeId !== questionControlTypeId ||
          item.options !== options ||
          item.displayType !== displayType ||
          item.questionPlaceholder !== questionPlaceholder ||
          item.qFormula !== qFormula ||
          item.buttonTypeReferenceValue !== buttonTypeReferenceValue ||
          JSON.stringify(item.tableReference) !== JSON.stringify(tableReference)
      );
    }
    return false;
  };

  const [repeatColumnLogic, setRepeatColumnLogic] = useState(
    questionColumnDetails?.repeatLogic == true
  );
  const [isColumnDetailUpdated,setIsColumnDetailUpdated]=useState(false);
  useEffect(() => {
    if (questionColumnDetails.length == 0 && numberOfColumns === 0) return;

    if (questionColumnDetails.length === 0 && numberOfColumns > 0) {
      const newQuestionColumnDetails = [];

      for (let i = 1; i <= Math.abs(numberOfColumns); i++) {
        const newObject = {
          ...defaultQuestionColumnDetailObject,
          columnNo: i,
          checklistQuestionColumnDetailsId: 0,
          repeatColumnLogic: i === 1,
        };
        newQuestionColumnDetails.push(newObject);
      }
      setQuestionColumnDetails(newQuestionColumnDetails);
    } else if (questionColumnDetails.length < numberOfColumns) {
      const newQuestionColumnDetails = [...questionColumnDetails];

      for (
        let i = questionColumnDetails.length + 1;
        i <= numberOfColumns;
        i++
      ) {
        const lastObject =
          newQuestionColumnDetails[newQuestionColumnDetails.length - 1];
        const oldCopiedObject = {
          ...lastObject,
          columnNo: lastObject.columnNo + 1,
          checklistQuestionColumnDetailsId: 0,
        };
        // const olCopiedObject = {
        //   ...defaultQuestionColumnDetailObject,
        //   columnNo: lastObject.columnNo + 1,
        // };
        // if (repeatColumnLogic) {
        //   newQuestionColumnDetails.push(olCopiedObject);
        // } else newQuestionColumnDetails.push(newObject);
        newQuestionColumnDetails.push(oldCopiedObject);
      }

      setQuestionColumnDetails(newQuestionColumnDetails);
    } else if (questionColumnDetails.length > numberOfColumns) {
      const newQuestionColumnDetails = questionColumnDetails.slice(
        0,
        numberOfColumns
      );
      setQuestionColumnDetails(newQuestionColumnDetails);
    }
  }, [numberOfColumns]);

  useEffect(() => {
    if (repeatColumnLogic && questionColumnDetails?.length > 0) {
      const firstObject = _.cloneDeep(questionColumnDetails[0]);
      setQuestionColumnDetails((prevDetails) =>
        prevDetails.map((item, index) => {
          if (index === 0) {
            return item;
          } else {
            return {
              ...firstObject,
              columnNo: item.columnNo,
              checklistQuestionColumnDetailsId:
                item.checklistQuestionColumnDetailsId,
              repeatColumnLogic: false,
            };
          }
        })
      );
      setIsColumnDetailUpdated(false);
    }
  }, [repeatColumnLogic, isColumnDetailUpdated]);

  const handleQuestionColumnDetailData = (
    localQuestionColumnDetail,
    columnNo
  ) => {
    setQuestionColumnDetails((prevState) => {
      return prevState.map((item) => {
        if (item.columnNo === columnNo) {
          return {
            ...item,
            ...localQuestionColumnDetail,
          };
        }
        if (localQuestionColumnDetail.repeatLogic && item.columnNo > columnNo) {
          return {
            ...localQuestionColumnDetail,
            columnNo: item.columnNo,
            checklistQuestionColumnDetailsId:
              item.checklistQuestionColumnDetailsId,
            repeatColumnLogic: false,
            tableReference: {},
            qFormula: null,
            answer: null,
            type: null,
            displayType: 0,
            options: null,
            alignment: null,
            checkListUserInputId: 0,
            buttonTypeReferenceValue: null,
            hasUserInput: false,
          };
        }
        return item;
      });
    });
    setIsColumnDetailUpdated(true);
  };
  return (
    <>
      <ToastContainer />
      {questionColumnDetails?.map((q, index) => {
        if (repeatColumnLogic && q?.columnNo > 1) {
          return null; // Skip rendering this item
        }

        return (
          <div className="bg-white rounded border pt-0 px-0 mt-3" key={index}>
            <label className="personal-info-heading p-3 px-4 border-bottom mx-0">
              <b>Column {index + 1}</b>
            </label>
            {numberOfColumns > 0 && (
              <QuestionColumn
                columnNo={q?.columnNo}
                repeatColumnLogic={repeatColumnLogic}
                setRepeatColumnLogic={setRepeatColumnLogic}
                details={details}
                numberOfColumns={numberOfColumns}
                handleQuestionColumnDetailData={handleQuestionColumnDetailData}
                questionColumnDetail={q}
                defaultRepeatLogic={q?.repeatLogic == true}
                disableAll={details.hasUserInput}
              />
            )}
          </div>
        );
      })}
    </>
  );
}
